module.exports = __webpack_public_path__ + "img/swingVariabilityText4.4010d463.png";